export const mockAccessCodes = [
  {
    id: 1,
    value: 'Premium Access',
    code: 'AC001',
    quantity: 100,
    status: 'active'
  },
  {
    id: 2,
    value: 'Standard Access',
    code: 'AC002',
    quantity: 50,
    status: 'active'
  },
  {
    id: 3,
    value: 'Basic Access',
    code: 'AC003',
    quantity: 25,
    status: 'inactive'
  },
  {
    id: 4,
    value: 'Trial Access',
    code: 'AC004',
    quantity: 10,
    status: 'active'
  },
  {
    id: 5,
    value: 'Enterprise Access',
    code: 'AC005',
    quantity: 1000,
    status: 'active'
  },
  {
    id: 6,
    value: 'Limited Access',
    code: 'AC006',
    quantity: 5,
    status: 'suspended'
  }
];



export const accessCodeStatuses = [
  { value: 'active', label: 'Active', color: 'bg-green-100 text-green-800' },
  { value: 'inactive', label: 'Inactive', color: 'bg-gray-100 text-gray-800' },
  { value: 'suspended', label: 'Suspended', color: 'bg-red-100 text-red-800' },
  { value: 'expired', label: 'Expired', color: 'bg-orange-100 text-orange-800' }
];
